import React from 'react'
import { Link } from 'react-router-dom'
import './SocialLinkCard.css'

const SocialLinkCard = ({ socailIcon, socailLink}) => {
    return (
        <li className="SocialLinkItem"><Link to={ socailLink }>{ socailIcon }</Link></li>
    )
}

export default SocialLinkCard
